import { render, staticRenderFns } from "./takeaway-modal.vue?vue&type=template&id=06548dca&scoped=true&"
import script from "./takeaway-modal.js?vue&type=script&lang=js&"
export * from "./takeaway-modal.js?vue&type=script&lang=js&"
import style0 from "./takeaway-modal.scss?vue&type=style&index=0&id=06548dca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06548dca",
  null
  
)

export default component.exports